module.exports = "https://static.energy5.com/_next/static/images/ledBgEffect-784ce460c51838dd9fd4354296af9beb.webp";